import { Injectable } from '@angular/core';

/**
 * Root-scoped so the desktop sidebar's collapsed (icon-only rail) state can be shared
 * between HeaderComponent (owns the toggle button) and AppComponent (owns the grid
 * column width) without a parent/child @Input chain — same shape as PlusDoctor-v2's
 * own SidebarStateService, just a plain boolean instead of a signal since this app
 * isn't signal-based.
 */
@Injectable({
  providedIn: 'root'
})
export class SidebarStateService {
  collapsed = false;

  toggle(): void {
    this.collapsed = !this.collapsed;
  }

  setCollapsed(collapsed: boolean): void {
    this.collapsed = collapsed;
  }
}
